/**
 * Formats a tooltip title with its keyboard shortcut if available.
 * Placeholder – keyboard shortcuts config not yet ported.
 */
export function formatTooltipWithShortcut(title: string, _actionKey?: string): string {
  return title;
}

export function getShortcutForAction(_actionKey: string): string | undefined {
  return undefined;
}
